// 调用可查看测试用例：base-libs/tests/unit/grey.spec.js
const validate = {
  // 白名单校验
  uin: function(params, config) {
    const uin = params.uin;
    const list = (config.value || "").split(",");
    if (!uin || !list.length) {
      // 不在白名单 不允许通过
      return false;
    }
    return list.indexOf(uin) > -1;
  },
  // 尾号灰度
  suffix: function(params, config) {
    const uin = params.uin;
    if (!uin || !config.value) {
      return false;
    }
    const suffix = uin.slice(-1);
    const pattern = new RegExp(config.value);
    return pattern.test(suffix);
  },
};

/**
 * config:灰度配置
 * [{
 *  type: "uin",
 *  value: "asd,321,3210",
 *}]
 * params:待匹配样本
 * {
 *   uin:"123"  
 * }
 * customValidateMap:自定义规则 跟validate对象一致
 * */
export function checkMatch(config, params, customValidateMap = {}) {
  const totalValidateMap = Object.assign({}, validate, customValidateMap);
  for (let i = 0, l = config.length; i < l; i++) {
    const curConfig = config[i];
    const curValidate = totalValidateMap[curConfig.type];
    if (!curValidate) {
      // 找不到匹配方法
      continue;
    }
    const checkResult = curValidate(params, curConfig, totalValidateMap);
    if (checkResult) {
      return {
        result: checkResult,
        matchType: curConfig.type,
      };
    }
  }
  return {
    result: false,
    matchType: null,
  };
}
